import { useCallback } from 'react';

import { Props as DatePickerProps } from 'e100-react-components/lib/components/DatePicker/types';

import { useFilterFormContext } from '../context';

export const useShouldDisableStartDate = () => {
  const { endDate } = useFilterFormContext();

  const shouldDisableStartDate: DatePickerProps['shouldDisableDate'] = useCallback((date: any) => {
    return !date.isBefore(endDate);
  }, [endDate]);

  return shouldDisableStartDate;
};
